<template>
  <div class="code-verify is-flex d-placeitem d-placecontent">
    <div class="">
      <figure class="image-code has-text-centered">
        <img
          src="/images/account/otp.png"
          class="otp-image"
          style="width: 55px; height: 96 px; margin: auto"
        />
      </figure>
      <div class="has-text-grey mt-3 my-4">
        <p class="has-text-centered text-14">
          <strong>{{ currentCountryCode }} {{ currentPhoneNumber }}</strong
          ><br />
          {{ $t('We’ve sent an SMS with an activation code to your phone') }}
        </p>
      </div>
      <div class="has-text-grey text-14 has-text-weight-semibold">
        {{ $t('Enter Verification Number') }}
      </div>
      <div class="is-flex is-content-space-between my-2">
        <input
          v-model="formValues.otp"
          class="input"
          type="text"
          :placeholder="$t('verificationCodePlaceholder')"
        />
      </div>
      <button
        :id="employer ? 'btn-employer-otp-verify' : 'btn-jobseeker-opt-verify'"
        :class="[employer || employerColor ? 'is-employer' : 'is-jobseeker']"
        :disabled="formValues.otp.length < 5"
        class="button has-text-white is-fullwidth"
        @click="verificationCode"
        v-text="$t('verify')"
      ></button>
      <div class="has-text-centered">
        <u class="text-orange"
          ><strong
            :id="
              employer ? 'link-employer-send-otp' : 'link-jobseeker-send-otp'
            "
            :class="[
              employer || employerColor
                ? 'has-text-employer'
                : 'has-text-jobseeker'
            ]"
            class="pointer text-14"
            @click="sendAgain"
            v-text="$t('Resend OTP')"
          ></strong
        ></u>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  props: {
    jobseeker: {
      type: Boolean
    },
    employer: {
      type: Boolean
    },
    employerColor: {
      type: Boolean
    }
  },
  data() {
    return {
      formValues: {
        otp: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      currentPhoneNumber: 'signup/currentPhoneNumber',
      currentCountryCode: 'signup/currentCountryCode',
      currentOtp: 'signup/currentOtp'
    })
  },
  methods: {
    ...mapMutations({
      updateOtp: 'signup/updateOtp'
    }),
    verificationCode() {
      this.updateOtp(this.formValues.otp)
      if (this.formValues.otp !== '' && this.currentPhoneNumber) {
        this.$axios
          .$post('/api/v1/auth/verify-otp/', {
            otp: this.formValues.otp,
            phone_number: '977-' + this.currentPhoneNumber
          })
          .then(response => {
            this.$emit('redirectToEmployerOverview')
            if (this.jobseeker === true) {
              this.$router.push(
                this.localePath({
                  name: 'signup-set-password'
                })
              )
            } else if (this.employer === true) {
              this.$router.push(
                this.localePath({
                  name: 'signup-employer-set-password'
                })
              )
            }
          })
          .catch(error => {
            if (error && error.response && error.response.data) {
              this.notifyError(error.response.data.otp[0])
            } else {
              this.notifyError('Something went wrong. Please Try Again.')
            }
          })
      } else {
        this.notifyError(this.$t('Phone Number should range from 7-10.'))
      }
    },
    sendAgain() {
      this.$axios
        .$post('/api/v1/auth/generate-otp/', {
          phone_number: '977-' + this.currentPhoneNumber,
          otp: this.formValues.otp
        })
        .then(response => {
          this.notifyUser(this.$t('verificationCodeSent'))
          this.updateOtp(response.otp)
        })
        .catch(error => {
          if (error.response.data.error) {
            this.notifyError(error.response.data.error)
          }
        })
    }
  }
}
</script>

<style scoped></style>
